import { GENERAL_ASSISTANT_ROWS } from '@/components/Settings/generalConstants'
import { SiaAssistantPreferenceRow } from '@/components/Settings/SiaAssistantPreferenceRow'

const ROW_ORDER = ['sia-enabled', 'listen-for', 'keyboard-shortcut', 'language', 'responses']

/**
 * @param {{
 *   values: Record<string, boolean | string>,
 *   setValues: React.Dispatch<React.SetStateAction<Record<string, boolean | string>>>,
 * }} props
 */
export function SiaAssistantPreferenceRows({ values, setValues }) {
  const orderedRows = ROW_ORDER.map((id) => GENERAL_ASSISTANT_ROWS.find((row) => row.id === id)).filter(Boolean)
  const lastIndex = orderedRows.length - 1

  return (
    <>
      {orderedRows.map((row, index) => (
        <SiaAssistantPreferenceRow
          key={row.id}
          row={row}
          groupPosition={index === 0 ? 'first' : index === lastIndex ? 'last' : 'middle'}
          compactY={index === lastIndex ? true : row.id !== 'keyboard-shortcut'}
          values={values}
          setValues={setValues}
        />
      ))}
    </>
  )
}
